import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, finalize } from "rxjs";
import { v4 } from "uuid";
import { AppActions } from "../state/actions/app.actions";

@Injectable({
  providedIn: "root"
})
export class RequestQueueService {
  constructor(private readonly store: Store) {}

  public process<T>(request: Observable<T>) {
    const id = v4();

    this.store.dispatch(
      AppActions.queueRequest({
        id
      })
    );

    return request.pipe(finalize(() => this.resolve(id)));
  }

  private resolve(id: string) {
    this.store.dispatch(
      AppActions.resolveRequest({
        id
      })
    );
  }
}
